import { render, staticRenderFns } from "./MonoFacebookIcon.vue?vue&type=template&id=cb0b8d42&scoped=true"
import script from "./MonoFacebookIcon.vue?vue&type=script&lang=js"
export * from "./MonoFacebookIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0b8d42",
  null
  
)

export default component.exports